import React from "react";
const SvgMapLocalizationIos = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M19.888 6.345L14.896 19.81a.521.521 0 01-.017.055c-.59 1.6-2.905 1.478-3.314-.182v-.001l-1.447-5.785-5.8-1.456h-.001c-1.65-.42-1.787-2.72-.18-3.313l13.518-5.017c1.39-.52 2.753.841 2.233 2.233zm-.936-.35a.737.737 0 00-.947-.946L4.484 10.067h-.001c-.673.248-.63 1.224.08 1.405l6.089 1.53a.5.5 0 01.363.363l1.52 6.079c.169.685 1.119.754 1.391.114a.511.511 0 01.015-.049l5.01-13.513v-.001z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapLocalizationIos;
